import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "w-full mt-3" }
const _hoisted_3 = { class: "therapyNameBox block" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = {
  class: "my-1 mr-1 checkboxWrapper",
  style: {"background-color":"#adadad"}
}
const _hoisted_6 = { class: "checkboxLabel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "formTitle" }, "THERAPY", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.therapy.therapyName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "formTitle" }, "DOCTORS", -1)),
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_v_checkbox, {
          modelValue: _ctx.doctorsSelectedAll,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doctorsSelectedAll) = $event)),
          label: "All",
          value: true,
          "hide-details": "",
          density: "compact",
          color: "white",
          class: "my-0 mx-0 doctorCheckbox"
        }, {
          label: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "checkboxLabel" }, "All", -1)
          ]))]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.therapy.doctors, (doctor) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "my-1 mr-1 checkboxWrapper defaultBgForCheckboxes",
          key: doctor.externalId,
          style: _normalizeStyle({backgroundColor: doctor.color})
        }, [
          _createVNode(_component_v_checkbox, {
            modelValue: _ctx.selectedDoctors,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDoctors) = $event)),
            color: "white",
            label: _ctx.$filters.initials(doctor.name),
            value: doctor.externalId,
            title: doctor.name,
            "hide-details": "",
            density: "compact",
            class: "my-0 mx-0 doctorCheckbox"
          }, {
            label: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(doctor.name), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "label", "value", "title"])
        ], 4))
      }), 128))
    ])
  ]))
}